<template>
  <div class="content">
    <div class="row">
      <div class="col-7 ignore-screen">
        <h1 class="font-light">
          <span v-if="canChange()">
            Change
          </span>
          User Details
        </h1>
      </div>
      <div class="col-5 u-fill-width ignore-screen">
        <div class="u-text-right u-fill-width">
          <back-button></back-button>
          <button
            v-if="canChange()"
            class="btn-link u-inline tas-heading-button"
            v-on:click="save"
          >
            <loading-spinner v-show="submit"></loading-spinner>
            <i class="fa-wrapper fa fa-save pad-right" v-show="!submit"></i>
            Save
          </button>
        </div>
      </div>
    </div>
    <div class="divider u-no-margin"></div>
    <!-- Errors and Success -->
    <server-error v-bind:error="error.serverError"></server-error>
    <toast-success
      v-if="success"
      label="Details Saved!"
      message="Your changes were successfully saved to the server."
      v-on:close="closeSuccess"
    ></toast-success>
    <!-- The forms -->
    <space></space>
    <div class="section">
      <h6 class="font-light">Name and Authentication</h6>
      <div class="form-section u-fill-width">
        <div class="section-body row">
          <div class="col-2 u-vertical-center ignore-screen">
            <label class="font-bold">Name</label>
          </div>
          <div class="col-5 ignore-screen input-control u-fill-width">
            <input
              v-if="canChange()"
              class="input-small"
              type="text"
              placeholder="First Name"
              v-model="user.first_name"
              v-bind:class="{ 'input-error': error.first_name }"
            />
            <span v-else>{{ user.first_name }} {{ user.last_name }}</span>
            <span class="error" v-if="error.first_name">
              {{ error.first_name }}
            </span>
          </div>
          <div class="col-5 ignore-screen input-control u-fill-width">
            <input
              v-if="canChange()"
              class="input-small"
              type="text"
              placeholder="Last Name"
              v-model="user.last_name"
              v-bind:class="{ 'input-error': error.last_name }"
            />
            <span class="error" v-if="error.last_name">
              {{ error.last_name }}
            </span>
          </div>
        </div>
        <div class="section-body row">
          <div class="col-2 ignore-screen u-vertical-center">
            <label class="font-bold">ARN</label>
          </div>
          <div class="col-10 ignore-screen">
            <div class="input-control">
              <input
                v-if="canChange()"
                class="input-small"
                style="max-width: 12rem;"
                type="number"
                placeholder="654321"
                v-model="user.arn"
                v-bind:class="{ 'input-error': error.arn }"
              />
              <span v-else>{{ user.arn }}</span>
              <div class="error" v-if="error.arn">
                {{ error.arn }}
              </div>
            </div>
          </div>
        </div>
        <div class="section-body row">
          <div class="col-2 ignore-screen u-vertical-center">
            <label class="font-bold">Email</label>
          </div>
          <div class="col-10 ignore-screen input-control u-fill-width">
            <input
              class="input-small"
              type="email"
              value="Your.Email@world.com"
              v-model="user.email"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="section">
      <h6 class="font-light">Personal Details</h6>
      <div class="form-section u-fill-width">
        <div class="section-body row">
          <div class="col-2 ignore-screen u-vertical-center">
            <label class="font-bold">Date of Birth</label>
          </div>
          <div class="col-4 ignore-screen input-control">
            <input
              class="input-small"
              type="date"
              value="2020-01-01"
              min="1920-01-01"
              max="2020-01-01"
              v-model="user.profile.date_of_birth"
            />
          </div>
        </div>
        <div class="section-body row">
          <div class="col-2 ignore-screen u-vertical-center">
            <label class="font-bold">Mobile</label>
          </div>
          <div class="col-4 ignore-screen input-control">
            <input
              class="input-small"
              type="tel"
              pattern="\+[0-9]{2} [0-9]{3} [0-9]{3} [0-9]{3}"
              placeholder="(0)412 345 678"
              v-model="user.profile.phone"
            />
          </div>
        </div>
        <div class="section-body row">
          <div class="col-2 ignore-screen u-vertical-center u-text-right">
            <label class="font-bold">Home Address</label>
          </div>
          <div class="col-10 ignore-screen input-control">
            <input
              class="input-small"
              type="text"
              placeholder="123 Qantas Ave, Brisbane Airport, Qld, 4001"
              v-model="user.profile.residential_address"
            />
          </div>
        </div>
        <div class="section-body row">
          <div class="col-2 ignore-screen u-vertical-center u-text-right">
            <label class="font-bold">Postal Address</label>
          </div>
          <div class="col-10 ignore-screen input-control">
            <input
              class="input-small"
              type="text"
              placeholder="123 Qantas Ave, Brisbane Airport, Qld, 4001"
              v-model="user.profile.postal_address"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <h6 class="font-light">Next of Kin</h6>
      <div class="form-section u-fill-width">
        <div class="section-body row">
          <div class="col-2 ignore-screen u-vertical-center u-text-right">
            <label class="font-bold">Name</label>
          </div>
          <div class="col-10 ignore-screen input-control">
            <input
              class="input-small"
              type="text"
              placeholder="John Smith"
              v-model="user.profile.next_of_kin"
            />
          </div>
        </div>
        <div class="section-body row">
          <div class="col-2 ignore-screen u-vertical-center u-text-right">
            <label class="font-bold">Relation</label>
          </div>
          <div class="col-6 ignore-screen input-control">
            <input
              class="input-small"
              type="text"
              placeholder="Husband / Wife / Parent / Dog"
              v-model="user.profile.next_of_kin_relation"
            />
          </div>
        </div>
        <div class="section-body row">
          <div class="col-2 ignore-screen u-vertical-center">
            <label class="font-bold">Phone</label>
          </div>
          <div class="col-4 ignore-screen input-control">
            <input
              class="input-small"
              type="tel"
              pattern="\+[0-9]{2} [0-9]{3} [0-9]{3} [0-9]{3}"
              placeholder="(0)412 345 678"
              v-model="user.profile.next_of_kin_phone"
            />
          </div>
        </div>
        <div class="section-body row">
          <div class="col-2 ignore-screen u-vertical-center u-text-right">
            <label class="font-bold">Address</label>
          </div>
          <div class="col-10 ignore-screen input-control">
            <input
              class="input-small"
              type="text"
              placeholder="123 Qantas Ave, Brisbane Airport, Qld, 4001"
              v-model="user.profile.next_of_kin_address"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
import { mapGetters } from "vuex";
import * as authService from "@/services/auth.service";
import { handleError } from "@/functions/handleError.function";
import ServerError from "@/components/ServerError";
import BackButton from "@/components/BackButton";
import LoadingSpinner from "@/components/LoadingSpinner";
import ToastSuccess from "@/components/ToastSuccess";

export default {
  name: "user-change",
  components: {
    ServerError,
    BackButton,
    LoadingSpinner,
    ToastSuccess
  },
  data: function() {
    return {
      user: {
        profile: {}
      },
      submit: false,
      success: false
    };
  },
  computed: {
    ...mapGetters("core", ["error"]),
    ...mapGetters("auth", ["userProfile", "permissions"]),
    userId: function() {
      return this.$route.params.userId;
    }
  },
  methods: {
    getUserData: function() {
      // Get the User model data from the server
      authService
        .getUserProfile(this.userId)
        .then(response => {
          this.user = response.data;
        })
        .catch(error => {
          let data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    },
    canChange: function() {
      let is_self = this.userProfile.id == this.$route.params.userId;
      let has_change_perm = this.permissions.includes(
        "auth-taslytic.change_taslyticuser"
      );
      return is_self || has_change_perm;
    },
    isValid: function() {
      let valid = true;
      // Required fields
      let required = ["first_name", "last_name"];
      for (let field of required) {
        if (this.user[field] == "") {
          let data = {};
          data[field] = "This field is required.";
          this.$store.commit("core/setError", data);
          valid = false;
        }
      }
      // ARN is sensible
      let val = this.user.arn;
      if (this.user.arn != "" && (val < 1000 || val > 9999999)) {
        let data = { arn: "The ARN must be 4 to 7 digits long." };
        this.$store.commit("core/setError", data);
        valid = false;
      }
      return valid;
    },
    save: function() {
      this.$store.commit("core/clearErrors");
      this.success = false;
      this.submit = true;
      if (!this.isValid()) {
        this.submit = false;
        return; // Break
      }
      authService
        .changeUser(this.userId, this.user)
        .then(response => {
          this.submit = false;
          this.success = true;
          this.$store.commit("auth/setUserProfile", response.data);
        })
        .catch(error => {
          this.submit = false;
          this.success = false;
          let data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    },
    closeSuccess: function() {
      this.success = false;
    }
  },
  mounted() {
    this.getUserData(this.userId);
  }
};
</script>
